export const preloadImages = async (images, remove = false) => {
  if (window.chronosImages === undefined) {
    window.chronosImages = {};
  }
  if (remove) {
    images.forEach((img) => {
      if (window.chronosImages[img._id] !== undefined) {
        window.chronosImages[img._id] = undefined;
      }
    });
  } else {
    //check if image is over a certain size first!
    images.forEach((img) => {
      if (Array.isArray(img)) {
        if (img[0] === undefined) {
          console.log('[PreCacher] Error: ImageData not defined.');
          return;
        } else {
          img = img[0];
        }
      }

      if (img.url && img.url !== null && img.url !== '') {
        const newImage = new Image();
        newImage.onerror = function () {
          console.log('[PreCacher] Error: Image URL is unreachable.', img);
          if (window.chronosImages[img._id]) {
            window.chronosImages[img._id] === undefined;
          }
        };
        newImage.src = img.url;
        window.chronosImages[img._id] = newImage;
      } else {
        console.log(
          '[PreCacher] Error: The supplied URL for the image is not valid.'
        );
      }
    });
  }
};
